export const THEME = {
    colors: {
        primary: '#2ECC40',
        secondary: '#1a1a1a',
        accent: '#4CAF50',
        background: '#ffffff',
        text: {
            primary: '#1a1a1a',
            secondary: '#666666',
            light: '#888888'
        },
        gradients: {
            green: 'linear-gradient(135deg, #2ECC40 0%, #4CAF50 100%)',
            darkGreen: 'linear-gradient(135deg, #388E3C 0%, #2E7D32 100%)',
            lightGreen: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)',
            blue: 'linear-gradient(135deg, #4A90E2 0%, #357ABD 100%)',
            accent: 'linear-gradient(135deg, #FF6B6B 0%, #E53E3E 100%)'
        },
        hover: {
            green: 'linear-gradient(135deg, #3DD447 0%, #5CBF60 100%)',
            darkGreen: 'linear-gradient(135deg, #43A047 0%, #388E3C 100%)',
        }
    },
    shadows: {
        card: '0 4px 24px rgba(0,0,0,0.06)',
        green: '0 4px 24px rgba(46,204,64,0.2)',
        darkGreen: '0 4px 24px rgba(76,175,80,0.2)',
        hover: '0 8px 32px rgba(0,0,0,0.12)'
    },
    spacing: {
        section: '3rem',
        element: '1.5rem',
    },
    borderRadius: {
        sm: '8px',
        md: '12px',
        lg: '16px'
    },
    // Histomart specific green colors
    histomart: {
        primary: '#2ECC40',
        secondary: '#4CAF50',
        tertiary: '#388E3C',
        dark: '#2E7D32',
        light: '#E8F5E9',
        background: 'rgba(46, 204, 64, 0.03)',
        searchBackground: '#E8F5E9'
    }
};